// General
import React, { useState, useContext, useRef } from "react";

// Contexts
import { DealersContext } from "../data/dealers/DealersContex";

// Core / Table
import TablePage from "../core/TablePage";

// Modals
import DealersAddModal from "../modals/dealers/DealersAddModal";
import DealersUpdateModal from "../modals/dealers/DealersUpdateModal";

// UI / PrimeReact
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";

// Icons
import { FaTrash, FaPencilAlt } from "react-icons/fa";
import { useData } from "../data/general/DataContext";

function DealersPage() {
    const { dealersList, deleteDealer } = useContext(DealersContext);

    // State
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const { windowMode } = useData();

    // Action menu
    const ActionMenu = ({ rowData }) => {
        const op = useRef(null);
        if (windowMode === "mobile") return null;
        return (
            <>
                <Button
                    label="..."
                    className="p-button-rounded p-button-text"
                    style={{ minWidth: "40px", fontSize: "22px", fontWeight: "bold" }}
                    onClick={(e) => op.current.toggle(e)}
                />
                <OverlayPanel ref={op} dismissable showCloseIcon={false}>
                    <div className="flex flex-col gap-0 p-2 w-32">
                        <Button
                            icon={<FaPencilAlt />}
                            label="Düzenle"
                            className="p-button-text w-full justify-start"
                            onClick={() => {
                                setSelectedDealer(rowData);
                                setShowUpdateModal(true);
                                op.current.hide();
                            }}
                        />
                        <div className="w-full border-t border-gray-300 my-1"></div>
                        <Button
                            icon={<FaTrash />}
                            label="Sil"
                            className="p-button-text w-full justify-start"
                            style={{ color: "red" }}
                            onClick={() => {
                                deleteDealer(rowData.id);
                                op.current.hide();
                            }}
                        />
                    </div>
                </OverlayPanel>
            </>
        );
    };

    // Table columns
    const columns = [
        { field: "id", header: "ID", hideInFilter: true },
        { field: "name", header: "Bayi Adı" },
        { field: "status", header: "Durum" },
        {
            header: "İşlemler",
            body: (rowData) =>
                windowMode === "mobile" ? (
                    // Mobil görünümde direkt butonlar
                    <div className="flex gap-2 mt-2 w-full">
                        <Button
                            icon={<FaPencilAlt />}
                            label="Düzenle"
                            className="flex-1"
                            style={{
                                backgroundColor: "#3b82f6",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                height: "26px",
                                fontSize: "10px",
                                justifyContent: "center",
                                gap: "4px",
                                padding: "0 6px",
                            }}
                            onClick={() => {
                                setSelectedDealer(rowData);
                                setShowUpdateModal(true);
                            }}
                        />
                        <Button
                            icon={<FaTrash />}
                            label="Sil"
                            className="flex-1"
                            style={{
                                backgroundColor: "#ef4444",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                height: "26px",
                                fontSize: "10px",
                                justifyContent: "center",
                                gap: "4px",
                                padding: "0 6px",
                            }}
                            onClick={() => deleteDealer(rowData.id)}
                        />
                    </div>
                ) : (
                    <ActionMenu rowData={rowData} />
                ),
            hideInFilter: true,
        },];

    // Filter dealers
    const filteredDealers = dealersList.filter(
        (d) =>
            !searchTerm ||
            d.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.status.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const columnFilterOptions = {
        name: { type: "text" },
        status: { type: "text" },
    };

    return (
        <>
            <div className="p-6">
                <TablePage
                    title="Bayi Listesi"
                    subTitle="Bayi ekleyebilir, düzenleyebilir veya silebilirsiniz."
                    columns={columns}
                    data={filteredDealers}
                    defaultRows={10}
                    rowsPerPageOptions={[10, 15, 25, 50,100]}
                    showSearch
                    searchValue={searchTerm}
                    onSearchChange={(e) => setSearchTerm(e.target.value)}
                    onAdd={() => setShowAddModal(true)}
                    columnFilterOptions={columnFilterOptions}
                />
            </div>

            {/* Modals */}
            <DealersAddModal isOpen={showAddModal} onClose={() => setShowAddModal(false)} />
            <DealersUpdateModal
                isOpen={showUpdateModal}
                onClose={() => setShowUpdateModal(false)}
                dealerId={selectedDealer ? selectedDealer.id : null}
            />
        </>
    );
}

export default DealersPage;